import type { MyAxiosResponseData } from '../sdk/types';
import type { MediaAction, MediaType, MediaDeviceListRes } from '../sdk/types/media';
import { AbstractApi } from './Api';

export interface MediaCallOptions {
  session_id: string;
  type: MediaType;
  room_id: string;
  membersId: string[];
}

export interface MediaOperateOptions {
  room_id: string;
  action: MediaAction;
}

export interface MediaSyncInfoOptions {
  room_id: string;
}

export interface MediaGetTokenOptions {
  room_id?: string;
}

export class MediaApi extends AbstractApi {
  call({ session_id, type, room_id, membersId }: MediaCallOptions, abortSignal?: AbortSignal) {
    return this.client.invoke(
      'mediaCallOperate',
      [type, session_id, room_id, membersId],
      abortSignal
    );
  }
  operate({ room_id, action }: MediaOperateOptions, abortSignal?: AbortSignal) {
    return this.client.invoke('mediaCallCalleeOperateRequest', [action, room_id], abortSignal);
  }
  getInfo({ room_id }: MediaSyncInfoOptions, abortSignal?: AbortSignal) {
    return this.client.invoke('mediaCallSyncInfo', [room_id], abortSignal);
  }
  getToken(args?: MediaGetTokenOptions, abortSignal?: AbortSignal) {
    const { room_id = '' } = args || {};
    return this.client.invoke('getMediaCallToken', [room_id], abortSignal);
  }
  getGroupMediaInfo(gid: string) {
    return this.request<any>({
      url: '/api/v1/group/media/info',
      method: 'GET',
      params: {
        gid,
      },
    }).then((res) => res.data);
  }
  getUserMediaInfo() {
    return this.request<any>({
      url: '/api/v1/user/media/info',
      method: 'GET',
    }).then((res) => res.data);
  }
  getUserMediaDeviceList(body: { list: string[] }) {
    return this.request<MyAxiosResponseData<MediaDeviceListRes>>({
      url: '/api/v1/user/devices/media/list',
      method: 'POST',
      body,
    }).then((res) => res.data);
  }
  mediaCallReset(body: { room_id: string }) {
    return this.request<any>({
      url: '/api/v1/chat/media/call/reset',
      method: 'POST',
      body,
    }).then((res) => res.data);
  }
  mediaCallDrop() {
    return this.request<any>({
      url: '/api/v1/media/drop',
      method: 'POST',
    }).then((res) => res.data);
  }
}
